module.exports = __webpack_public_path__ + "media/step4_animation.ed23d482.mp4";